import { Web3DViewerWrapper } from '@trimble/web3d-utils';
import { Accessor, createSignal, Setter } from 'solid-js';
import { CapabilityProviderBase } from './provider-base';

/**
 * Shared provider is used across all viewers and contains shared state.
 */
export abstract class SharedCapabilityProviderBase<
  TModel,
> extends CapabilityProviderBase<TModel> {
  public viewerWrappers: Accessor<Web3DViewerWrapper[]>;
  protected setViewerWrappers: Setter<Web3DViewerWrapper[]>;

  constructor(derivedItems?: Accessor<TModel[]>) {
    super(derivedItems);
    const [viewerWrappers, setViewerWrappers] = createSignal<
      Web3DViewerWrapper[]
    >([]);
    this.viewerWrappers = viewerWrappers;
    this.setViewerWrappers = setViewerWrappers;
  }

  public addViewer(viewer: Web3DViewerWrapper): void {
    this.setViewerWrappers([viewer, ...this.viewerWrappers()]);
  }

  public removeViewer(viewer: Web3DViewerWrapper): void {
    this.setViewerWrappers(this.viewerWrappers().filter((v) => v != viewer));
  }
}
